import { useTranslation } from "react-i18next";

import { useTheme } from "@mui/system";

import { useAppDispatch } from "src/store/store";
import { openAccountViewer } from "src/store/slices/app/appSlice";

import TruncatedTextField, { TruncatedTextFieldProps } from "../truncate-text/truncated-text-field";

type Props = {
    accountId: string;
    textFieldProps: Omit<TruncatedTextFieldProps, 'children'>;
};

const AccountDisplay = ({ accountId, textFieldProps }: Props) => {

    const { t } = useTranslation();

    const dispatch = useAppDispatch();

    const theme = useTheme();

    const handleClick = () => {
        dispatch(openAccountViewer({ accountId }));
    }

    return (
        <TruncatedTextField
            {...textFieldProps}
            onClick={handleClick}
            sx={{
                cursor: 'pointer',
                color: theme.palette.primary.main,
                fontWeight: 'bold',
                '&:hover': {

                    textDecoration: 'underline'
                },
                ...textFieldProps.sx
            }}
            text={textFieldProps.text}
        />
    )

}

export default AccountDisplay;